
import {Injectable} from "@angular/core";
import {HttpClientService} from "../../../common/http-client.service";
import { CommonService } from '../../../common/common.service';
import { Http, Headers, RequestOptions, ResponseContentType } from "@angular/http";


@Injectable()
export class FinancialService {

    constructor(private common: CommonService,private http:HttpClientService) {
		
    }
 
 	getTrailBalance(fromDate,toDate){
        return this.http.get("getTrialBalance/"+fromDate+"/"+toDate+"/0", null, 16).map(res=>{return res});
    }

    getTotalTrailBalance(fromDate,toDate,walletTypeID){
        return this.http.get("getTrialBalance/"+fromDate+"/"+toDate+"/"+walletTypeID, null, 16).map(res=>{return res});
    }

    downloadTrialBalanceFile(param1,param2){
        console.log(localStorage.getItem('tkn'));
          let headObj: any = {
            // 'userId': this.common.getUserId(),
            'Authorization': localStorage.getItem('tkn')
        };
        let headers = new Headers(headObj);
        let reqHead = new RequestOptions({
            responseType: ResponseContentType.Blob,
            headers: headers
        });
        return this.http.get(`downloadTrialBalance/`+param1+"/"+param2, null, 16, reqHead, 'blob').subscribe((data) => {
            this.downloadcsv(data, 'trial_balance_sheet');
            console.log(data);
        });
        }
    
    
        downloadcsv(data, userId) {
          let a = document.createElement('a');
          a.setAttribute("id", "downloadCsv");
          let date = new Date();
          let Tdate = date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear();
          a.download = userId + '.csv';
          a.href = window.URL.createObjectURL(data);
          a.textContent = 'Download CSV';
          a.dataset.downloadurl = ["text/csv;charset=ISO-8859-1", a.download, a.href].join(':');
          document.body.appendChild(a);
          setTimeout(function () {
              document.getElementById('downloadCsv').click();
              document.getElementById('downloadCsv').remove();
          }, 1000);
      }

      getWalletType(){
        return this.http.get("getWalletTypes/-1",null,5).map(res=>{return res});
      }

      getTxnDetailReport(pFromDate,pToDate,pWalletTypeId,pOffSet,pLimit,pMinTxnCount,pMaxTxnCount,pMinTxnAmt,pMaxTxnAmt) {
          return this.http.get("getWalletTypeGL/"+pFromDate+"/"+pToDate+"/"+pWalletTypeId+"/"+pOffSet+"/"+pLimit+"/"+pMinTxnCount
          +"/"+pMaxTxnCount+"/"+pMinTxnAmt+"/"+pMaxTxnAmt+"/0"
          ,null,16).map(res=>{return res});
       }
      
       getTotalTxnDetailReport(pFromDate,pToDate,pWalletTypeId,pOffSet,pLimit,pMinTxnCount,pMaxTxnCount,pMinTxnAmt,pMaxTxnAmt,walletId) {
        return this.http.get("getWalletTypeGL/"+pFromDate+"/"+pToDate+"/"+pWalletTypeId+"/"+pOffSet+"/"+pLimit+"/"+pMinTxnCount
        +"/"+pMaxTxnCount+"/"+pMinTxnAmt+"/"+pMaxTxnAmt+"/"+walletId
        ,null,16).map(res=>{return res});
     }

    downloadTxnDetailReport(pFromDate,pToDate,pWalletId,pOffSet,pLimit,pMinTxnCount,pMaxTxnCount,pMinTxnAmt,pMaxTxnAmt) {
           
        console.log(localStorage.getItem('tkn'));
        let headObj: any = {
        //   'userId': this.common.getUserId(),
          'Authorization': localStorage.getItem('tkn')
      };
      let headers = new Headers(headObj);
      let reqHead = new RequestOptions({
          responseType: ResponseContentType.Blob,
          headers: headers
      });
      
      return this.http.get("downloadTxnDetail/"+pFromDate+"/"+pToDate+"/"+pWalletId+"/"+pOffSet+"/"+pLimit+"/"+pMinTxnCount+"/"+pMaxTxnCount+"/"+pMinTxnAmt+"/"+pMaxTxnAmt
      , null, 16, reqHead, 'blob').subscribe((data) => {
        this.downloadcsv(data, 'txn_detail_sheet');
        console.log(data);
        });
    }

    getWalletIDReport(pFromDate,pToDate,pWalletId,pOffSet,pLimit) {
        return this.http.get("getGeneralLedger/"+pFromDate+"/"+pToDate+"/"+pWalletId+"/"+pOffSet+"/"+pLimit
        ,null,16).map(res=>{return res});
     }

  downloadWalletIDReport(pFromDate,pToDate,pWalletId,pOffSet,pLimit) {
         
      console.log(localStorage.getItem('tkn'));
      let headObj: any = {
        // 'userId': this.common.getUserId(),
        'Authorization': localStorage.getItem('tkn')
    };
    let headers = new Headers(headObj);
    let reqHead = new RequestOptions({
        responseType: ResponseContentType.Blob,
        headers: headers
    });
    
    return this.http.get("dwldGeneralLedger/"+pFromDate+"/"+pToDate+"/"+pWalletId+"/"+pOffSet+"/"+pLimit
    , null, 16, reqHead, 'blob').subscribe((data) => {
      this.downloadcsv(data, 'general_ledger_sheet');
      console.log(data);
      });
  }
    
}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/main/reports/financial-reports/financial-reports.service.ts